import { useIntl } from 'react-intl';
import { Typography } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { DocumentModifier } from '../../document-list-base/helpers/resolveModifierFromUrl';

const RenderUser = (
  props: GridRenderCellParams<Record<never, never>, DocumentModifier>
) => {
  const intl = useIntl();
  const { value } = props;

  return (
    <Typography
      component="div"
      sx={{
        fontSize: 'inherit',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        verticalAlign: 'middle',
        display: 'inline-block',
      }}
    >
      {!value || value === 'none'
        ? ''
        : value === 'unknown'
          ? intl.formatMessage({
              id: `containers.documents.unknownModifier`,
            })
          : value.email || value.username}
    </Typography>
  );
};

export { RenderUser };
